import { InfoPopoverProps } from 'component-library';

import { PlotReportFactElement } from '@/api/rest/resources/types/fact';
import { CapsuleIconProps } from '@/components/Capsule/Capsule';
import {
  getNCChangeIcon,
  getNCChangeIconVariant,
  NCFactCapsule,
  NCFactCapsuleProps,
} from '@/components/NCFactCapsule/NCFactCapsule';

export type FactCapsuleProps = {
  fact: PlotReportFactElement;
  className?: string;
  tooltip?: { title: string; body: string };
  capsuleIconProps?: CapsuleIconProps;
} & NCFactCapsuleProps;

export const FactCapsule = ({ fact, className, tooltip, ...props }: FactCapsuleProps) => {
  const infoPopoverProps = tooltip ? ({ title: tooltip?.title, body: tooltip?.body } as InfoPopoverProps) : null;

  return (
    <NCFactCapsule
      fact={fact}
      className={className}
      infoPopoverProps={infoPopoverProps}
      capsuleIconProps={{
        icon: getNCChangeIcon(fact),
        variant: getNCChangeIconVariant(fact),
      }}
      {...props}
    />
  );
};
